<template>
  <div class="download">
    <div class="container">
      <h2 class="title">下载中心</h2>
      <div class="img">
        <ul>
          <li v-for="item in downloadList" :key="item.id">
            <img :src="item.photoUrl" alt="">
            <p>{{item.description}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {reqCarousel} from '../../api'
export default {
  data() {
    return {
      downloadList: []
    }
  },
  created() {
    reqCarousel(3).then(res => {
      console.log(res)
      if(res.code === 200) {
        this.downloadList = res.data.bussData
      }
    })
  }
}
</script>

<style scoped lang="less" type="text/less">
  .download{
    .title{
      padding:51px 0 41px;
      border-bottom: 1px solid #e1e1e1;
      font-size: 24px;
      font-family:Alibaba-PuHuiTi-H;
      font-weight: 800;
    }
    .img{
      margin-top:19px;
      margin-bottom: 340px;
      ul{
        display: flex;
        flex-wrap: wrap;
        li{
          margin: 0 50px 30px;
          img{
            display: block;
            width: 200px;
            height: 200px;
            background: #ccc;
          }
          p{
            text-align: center;
            margin-top:10px;
            font-size:20px;
            font-family:Alibaba-PuHuiTi-M;
            font-weight:500;
            color:rgba(51,51,51,1);
          }
        }
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Download/Download.vue